import React from "react";

const FractionBlock = ({ block }) => {
    return (
        <div
            style={{
                display: "flex",
                justifyContent: "center",
                margin: "20px 0",
            }}
        >
            <div
                style={{
                    display: "inline-flex",
                    flexDirection: "column",
                    alignItems: "center",
                    minWidth: 80,
                    fontSize: 24,
                    fontFamily: "serif",
                }}
            >
                <div
                    style={{
                        padding: "4px 16px",
                        borderBottom: "2px solid #111",
                    }}
                >
                    {block.numerator || ""}
                </div>

                <div
                    style={{
                        padding: "4px 16px",
                    }}
                >
                    {block.denominator || ""}
                </div>
            </div>
        </div>
    );
};

export default FractionBlock;